import { Context } from "lit-element-simple-context";
import { defaultState } from "../actions/default-state.js";

/**
 * @type {Context<defaultState>}
 */
const context = new Context();

context.init({ ...defaultState }, true, {
  target: window.parent,
  name: 'Devices UI',
  trace: !import.meta.env?.VITE_BUILD,
});

export default context;
